import { useTranslation } from "react-i18next";
import React from "react";
import { ApiInternal } from "src/api/api_internal";
import { UUID } from "src/api/api_common";
import { ConfirmDialog } from "src/components/base/confirm-dialog";

/**
 * The properties for {@link DeleteExtraDomainDialog}
 */
export type DeleteExtraDomainDialogProps = {
    /** The uuid of the dns */
    dns: UUID | undefined;
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback function when the Dialog is closed */
    onClose: () => void;
    /** Callback function when the file is deleted */
    onDelete: () => void;
};

/**
 * A dialog to delete a split-dns extra domain.
 */
export default function DeleteExtraDomainDialog(props: DeleteExtraDomainDialogProps) {
    const [t] = useTranslation("dialog-delete-extra-domain");

    if (!props.dns) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.dns) return;
                await ApiInternal.dns.deleteExtraDns(props.dns);
                props.onDelete();
            }}
            title={t("heading.delete-extra-domain")}
            description={t("description.delete-extra-domain")}
            confirmLabel={t("button.delete")}
            cancelLabel={t("button.cancel")}
        />
    );
}
